import { SnackbarOrigin } from '@mui/material';
import { SxProps } from '@mui/system';
import { ReactNode } from 'react';

interface BaseAlert {
  autoHideDuration: number | null;
  display: boolean;
  id?: string;
  isPermanent?: boolean;
  message: ReactNode;
  onAutoHide?: () => void;
  onClick?: () => void;
  sx?: SxProps;
  anchorOrigin?: SnackbarOrigin;
  hideCloseButton?: boolean;
}

interface Success extends BaseAlert {
  kind: 'success';
}

interface Info extends BaseAlert {
  kind: 'info';
}

interface Warn extends BaseAlert {
  kind: 'warn';
}
interface Error extends BaseAlert {
  kind: 'error';
}

export type Alert = Success | Info | Warn | Error;
export const AlertTypes = {
  error: 'error',
  info: 'info',
  success: 'success',
  warn: 'warn',
} as const;
export const alert = (
  message: ReactNode,
  kind: Alert['kind'],
  autoHideDuration?: number | null,
  onClick?: () => void,
  isPermanent?: boolean,
  sx?: SxProps,
  anchorOrigin?: SnackbarOrigin,
  hideCloseButton?: boolean,
  onAutoHide?: () => void,
): Alert => {
  const defaultAutoHideDuration = isPermanent ? null : 6000;

  return {
    message: message,
    kind,
    display: true,
    autoHideDuration:
      autoHideDuration === undefined ? defaultAutoHideDuration : autoHideDuration,
    onAutoHide,
    onClick,
    isPermanent,
    sx,
    anchorOrigin,
    hideCloseButton,
  } as Alert;
};
